import SessionProvider from "@context/session/SessionProvider";
import AppbarUI from "./Appbar";

export default function Appbar() {
	return (
		<SessionProvider>
			<AppbarUI />
		</SessionProvider>
	)
}